import {lighten, makeStyles} from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import {Button, Grid} from "@material-ui/core";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import React, {useMemo} from "react";
import clsx from "clsx";


export const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
                border: 0,
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 50%',
    },
}));

export const EnhancedTableToolbar = ({numSelected, selectedItem, data, Currency}) => {
    const classes = useToolbarStyles();   

    const isSomeThingSelected = useMemo(() => numSelected > 0, [numSelected])

    return (
        <>
            <Toolbar  className={clsx(classes.root, { [classes.highlight]: numSelected > 0 })}  hidden={!isSomeThingSelected}>
                <Grid container className={classes.title}>
                    <Grid>
                        <Button style={{marginRight: 20}}> {"Selected : " + numSelected} </Button>
                    </Grid>
                    <Grid> 
                        <ExcelFile
                            element={(
                                <Button style={{backgroundColor: "green", color: "white", marginRight: 30}}>
                                    Exporter en excel
                                </Button>
                            )}
                        >
                            <ExcelSheet data={selectedItem} name="Orders">
                                <ExcelColumn label="ProSoft Id" value="proSoftId"/>
                                <ExcelColumn label="Barcode" value="barcode"/>
                                <ExcelColumn label="Name" value="name"/>
                                <ExcelColumn label="Price" value="price"/>
                                <ExcelColumn label="Ordered Quantity" value="quantity"/>
                                <ExcelColumn label="Shipped Quantity" value="shippedQuantity"/>
                                <ExcelColumn label="Discount" value="discount"/>
                                <ExcelColumn label="Amount" value="amount"/>
                                <ExcelColumn label="Is Received" value="isReceived"/>
                                <ExcelColumn label="Sell Price" value="sellPrice"/>
                                <ExcelColumn label="Expires" value="expires"/>
                            </ExcelSheet>
                        </ExcelFile> 
                        {
                            Currency && Currency === "FCFA" ?
                            <ExcelFile
                                element={(
                                    <Button style={{backgroundColor: "green", color: "white"}}>
                                        Exporter tout en excel pour reception
                                    </Button>
                                )}
                            >
                                <ExcelSheet data={data} name="Orders">
                                    <ExcelColumn label="Code article" value="proSoftId"/>
                                    <ExcelColumn label="Référence" value="proSoftId"/>
                                    <ExcelColumn label="Code Bare" value="barcode"/>
                                    <ExcelColumn label="Nom article" value="name"/>
                                    <ExcelColumn label="Description" value="name"/>
                                    <ExcelColumn label="Qté achat" value="quantity"/> 
                                    <ExcelColumn label="Prix achat" value="price"/> 
                                    <ExcelColumn label="Prix de vente" value="sellPrice"/>
                                    <ExcelColumn label="Pack" value="HasClilds"/>
                                    <ExcelColumn label="Classe" value="ClassItem"/>
                                    <ExcelColumn label="Seuil réaprovisionnement" value="Threshold"/>
                                    <ExcelColumn label="N° Lot" value="expires"/> 
                                    <ExcelColumn label="Date expiration" value="expires"/>
                                </ExcelSheet>
                            </ExcelFile> : <div></div>
                        }
                        
                    </Grid>
                </Grid>
            </Toolbar>
        </>
    );
};
